module.exports = __webpack_public_path__ + "static/media/login-logo.11284d7a.svg";